import React from "react";
import { STATIC_ASSETS } from "../config";

import { Box, Heading } from "@chakra-ui/react";
import { Container } from "@mui/material";

import { BlinkBlur } from "react-loading-indicators";

/**
 * LoadingPage component renders a full-screen loading page with a logo, headings, and a loading animation.
 *
 * @component
 * @param {string} text - A text string to display below the logo. Usually the page name which is loading.
 * @example
 * return (
 *   <LoadingPage text={"R&S Daily Cost Page"} />
 * )
 */
const LoadingPage = ({ text }) => {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        caretColor: "transparent",
      }}
    >
      <Box>
        <img
          alt="RS Logo"
          width="128px"
          height="128px"
          src={STATIC_ASSETS.LOGO_URL}
        />
      </Box>
      <Heading mb={2} mt={2} fontSize="2xl">
        {text}
      </Heading>
      <Heading mb={4} fontSize="lg">
        Loading...
      </Heading>
      <Box mt={30}>
        <BlinkBlur color={STATIC_ASSETS.LOADING_INDICATOR_COLOR} size="medium" text="" textColor="" />
      </Box>
    </Container>
  );
};
export default LoadingPage;
